<template>
  <el-container class="pages-common pre-tax-index">
    <leftNav />
    <el-main
      class="main-body"
      v-loading="loading"
      element-loading-text="导入中,请稍候"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(238, 238, 238, 0.9)"
    >
      <div class="page-header">
        <div class="title">多人扣款管理</div>
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          style="display: inline-block"
        >
          <el-form-item label="姓名">
            <el-input
              v-model="formInline.name"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="工号">
            <el-input
              v-model="formInline.empNo"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              v-model="formInline.IDCord"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="OA流水号">
            <el-input
              v-model="formInline.serialNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="扣款项目">
            <el-input
              v-model="formInline.projectName"
              placeholder="请输入"
              clearable
            ></el-input>
            <!-- <el-select
              clearable
              v-model="formInline.projectName"
            >
              <el-option label="项目名称1" value="项目名称1"></el-option>
              <el-option label="项目名称2" value="项目名称2"></el-option> -->
            <!-- </el-select> -->
          </el-form-item>
          <el-form-item label="扣款出处">
            <el-select clearable v-model="formInline.source">
              <el-option label="工资" value="工资"></el-option>
              <el-option label="佣金" value="佣金"></el-option>
              <el-option label="合作费" value="合作费"></el-option>
              <el-option label="均可" value="均可"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应扣月份">
            <el-date-picker
              v-model="formInline.month"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              :unlink-panels="true"
            >
            </el-date-picker>
            <!-- <el-select
              clearable
              v-model="formInline.month"
              multiple
              :collapse-tags="true"
            >
              <el-option label="11月" value="11月"></el-option>
              <el-option label="12月" value="12月"></el-option>
              <el-option label="01月" value="01月"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="formInline.remark"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="onSubmit"
              >查询</el-button
            >
            <el-button type="warning" size="small" @click="onReset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          <el-upload
            class="upload-demo"
            :action="upfileUrl"
            :headers="myHeaders"
            :on-progress="uploadProgress"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :file-list="fileList"
            :show-file-list="false"
            accept=".xls,.xlsx"
          >
            <el-button size="small" type="primary">导入多人扣款</el-button>
          </el-upload>
          <el-button
            size="small"
            type="success"
            @click="downModel"
            :disabled="downDisabled"
            >下载多人扣款模板</el-button
          >
          <el-button
            size="small"
            type="info"
            @click="exportExcels"
            :disabled="exportDisabled"
            >导出记录</el-button
          >
          <el-button size="small" type="warning" @click="delMultipleCharge"
            >删除</el-button
          >
        </div>
        <!-- <el-button class="upload" size="small" type="success">上传类型表</el-button> -->
        <!-- <el-upload class="upload-demo" :action="actionUrl" :on-success='uploadSuccess' :on-error="uploadError" :file-list="fileList"

 :show-file-list="false" accept=".xls,.xlsx">

<el-button size="small" type="success">上传类型表</el-button>

</el-upload> -->
      </div>
      <div class="page-main">
        <el-table
          :data="tableData"
          border
          stripe
          size="small"
          max-height="500"
          :span-method="objectSpanMethod"
          :cell-style="cellStyle"
          :header-cell-style="{ borderColor: '#ccc' }"
        >
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <el-radio
                v-model="selectDeleteId"
                :label="scope.row.multipleCharge.id"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>

          <el-table-column label="导入时间" width="150" align="center">
            <template slot-scope="scope">
              {{
                scope.row.multipleCharge.createTime
                  | FormatDate("YYYY/mm/dd HH:MM:SS")
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="multipleCharge.createEmpName"
            label="导入人员"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="multipleCharge.oaNumber"
            label="OA流水号"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="multipleCharge.remark"
            label="备注"
            width="220"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="multipleCharge.chargeItem"
            label="扣款项目"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="multipleCharge.chargeFrom"
            label="扣款出处"
            width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="multipleCharge.shouldChargeMonth"
            label="应扣月份"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="multipleCharge.shouldChargeMoney"
            label="应扣金额"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="multipleCharge.noChargeMoney"
            label="当前剩余扣款"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="details.empName"
            label="姓名"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="details.empNo"
            label="工号"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="details.idCard"
            label="身份证号"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="details.dept"
            label="组别"
            width="140"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="details.realChargeMoney"
            label="实扣金额合计"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column label="实扣操作" class-name="excel-name">
            <template slot-scope="scope">
              <span
                @click="searchDetails(scope.row.details)"
                v-if="scope.row.details"
                >实扣明细</span
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>

      <el-dialog
        :title="detailsTitle"
        custom-class="details-table"
        :visible.sync="dialogVisible"
        width="851px"
        top="13vh"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeAddDetails"
      >
        <el-button
          class="add-details"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addDetailsVisible = true"
        >
          新 增
        </el-button>
        <el-table
          :data="detailsTable"
          border
          stripe
          size="small"
          max-height="400"
        >
          <el-table-column
            prop="realChargeMonth"
            label="实扣月份"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realChargeWage"
            label="本期工资实扣"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realChargeCoop"
            label="本期合作费实扣"
            width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realChargePerformance"
            label="本期绩效实扣"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realChargeCommission"
            label="本期佣金实扣"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realChargeBonus"
            label="本期花红实扣"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realChargeTotal"
            label="本期实扣合计"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                type="danger"
                plain
                size="mini"
                @click="delDetails(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="新增明细"
        custom-class="add-details"
        :visible.sync="addDetailsVisible"
        width="540px"
        top="13vh"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeAddDetailsItem"
      >
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="实扣月份">
            <el-date-picker
              v-model="form.month"
              type="month"
              placeholder="选择日期"
              value-format="yyyy-MM"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="本期工资实扣">
            <el-input
              v-model="form.realChargeWage"
              type="number"
              clearable
              placeholder="请填写本期工资实扣"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="本期合作费实扣">
            <el-input
              v-model="form.realChargeCoop"
              type="number"
              clearable
              placeholder="请填写本期合作费实扣"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="本期绩效实扣">
            <el-input
              v-model="form.realChargePerformance"
              type="number"
              clearable
              placeholder="请填写本期绩效实扣"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="本期佣金实扣">
            <el-input
              v-model="form.realChargeCommission"
              type="number"
              clearable
              placeholder="请填写本期佣金实扣"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="本期花红实扣">
            <el-input
              v-model="form.realChargeBonus"
              type="number"
              clearable
              placeholder="请填写本期花红实扣"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="本期实扣合计">
            <el-input v-model="form.realChargeTotal" type="number" disabled></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="addDetails">立即创建</el-button>
            <el-button @click="addDetailsVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import leftNav from "../components/nav.vue";
import {
  getMultipleCharge,
  getMultipleDetails,
  delMutipleDetails,
  addMutipleDetails,
  delMultiple,
  validate,
} from "../api/index";
import rootUrl from "../utils/api";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      formInline: {},
      currentPage: 1,
      total: 40,
      pageSize: 20,
      tableData: [
        {
          importTime: "2020-12-16 14:02:57",
          importName: "测试人员",
          serialNumber: "000001",
          projectName: "项目名称",
          source: "合作费",
          month: "2020年12月",
          money: 10000.0,
          surplusMoney: 10000.0,
          name: "测试",
          empNo: "HB18041245",
          IDCard: "513154214535421536X",
          dept: "测试部门",
          moneyTotal: 10000.0,
          remark: "备注信息备注信息备注信息",
        },
      ],
      fileList: [],
      dialogVisible: false,
      addDetailsVisible: false,
      detailsTable: [
        // {
        //   month: "2020年10月",
        //   wagesDeduction: 500.0,
        //   collaborateDeduction: 100.0,
        //   achievementsDeduction: 100.0,
        //   commissionDeduction: 100.0,
        //   bonusDeduction: 100.0,
        //   total: 900.0,
        //   id: "00001",
        // },
      ],
      form: {},
      startTime: "",
      endTime: "",
      spanArr: [],
      position: 0,
      myHeaders: {
        token: this.$store.state.loginToken,
      },
      upfileUrl: rootUrl + "/multiple-charge/upload",
      detailsTitle: "",
      selectDetailsId: "",
      selectDeleteId: "",
      exportDisabled: false,
      downDisabled: false,
      loading: false,
    };
  },
  mounted() {
    document.title = "多人扣款";
    this.queryList();
  },
  methods: {
    queryList() {
      let data = {
        chargeFrom: this.formInline.source ? this.formInline.source : "",
        chargeItem: this.formInline.projectName
          ? this.formInline.projectName
          : "",
        current: this.currentPage,
        empName: this.formInline.name ? this.formInline.name : "",
        empNo: this.formInline.empNo ? this.formInline.empNo : "",
        idCard: this.formInline.IDCord ? this.formInline.IDCord : "",
        oaNumber: this.formInline.serialNumber
          ? this.formInline.serialNumber
          : "",
        remark: this.formInline.remark ? this.formInline.remark : "",
        shouldChargeMonthEnd: this.endTime,
        shouldChargeMonthStart: this.startTime,
        size: this.pageSize,
      };
      getMultipleCharge(data)
        .then((res) => {
          if (res.code == 200) {
            var tempArr = JSON.parse(JSON.stringify(res.data.rows));
            var newArr = [];
            tempArr.map((item, index) => {
              if (item.details.length == 0) {
                newArr.push({
                  index: index,
                  multipleCharge: item.multipleCharge,
                  details: "",
                });
              } else {
                item.details.map((items) => {
                  var tempItem = {
                    index: index,
                    multipleCharge: item.multipleCharge,
                    details: items,
                  };
                  newArr.push(tempItem);
                });
              }
            });
            this.tableData = newArr;
            this.rowspan();
            this.total = res.data.total;
            console.log(this.tableData);
          } else {
            this.showMessage("error", res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit() {
      //   console.log("onSubmit");
      //   console.log(this.formInline);
      this.currentPage = 1;
      this.queryList();
    },
    onReset() {
      //   console.log("onReset");
      this.formInline = {};
      this.currentPage = 1;
      this.startTime = "";
      this.endTime = "";
      this.queryList();
    },
    uploadProgress(response, file, fileList) {
      this.loading = true;
    },
    uploadSuccess(response, file, fileList) {
      //   console.log(response);
      //   console.log(file);
      if (response.code == 200) {
        this.showMessage("success", response.message);
      } else {
        this.showMessage("error", response.message);
      }
      this.loading = false;
      this.currentPage = 1;
      this.queryList();
    },
    uploadError(err, file, fileList) {
      console.log(err);
      console.log(file);
      this.loading = false;
      this.currentPage = 1;
      this.queryList();
    },
    addDetails() {
      if (!this.form.month) {
        console.log("请输入月份");
        this.showMessage("error", "请选择实扣月份");
        return false;
      }
      var data = {
        multipleChargeDetailId: this.selectDetailsId,
        realChargeBonus: this.form.realChargeBonus
          ? this.form.realChargeBonus
          : "",
        realChargeCommission: this.form.realChargeCommission
          ? this.form.realChargeCommission
          : "",
        realChargeCoop: this.form.realChargeCoop
          ? this.form.realChargeCoop
          : "",
        realChargeMonth: this.form.month ? this.form.month : "",
        realChargePerformance: this.form.realChargePerformance
          ? this.form.realChargePerformance
          : "",
        realChargeWage: this.form.realChargeWage
          ? this.form.realChargeWage
          : "",
      };
      addMutipleDetails(data)
        .then((res) => {
          if (res.code == 200) {
            this.showMessage("success", "新建成功");
          } else {
            this.showMessage("error", res.message);
          }
          getMultipleDetails(this.selectDetailsId)
            .then((res) => {
              this.detailsTable = res.data.rows;
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch((res) => {
          console.log(res);
        });

      this.addDetailsVisible = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryList();
      console.log(`当前页: ${val}`);
    },
    showMessage(type, msg) {
      this.$message({
        message: msg,
        type: type,
        duration: 5000,
        center: true,
      });
    },
    dateChange() {
      if (this.formInline.month == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        this.startTime = this.formInline.month[0];
        this.endTime = this.formInline.month[1];
      }
    },

    //获得数据相同的行数
    rowspan() {
      //每次调用清空数据
      this.spanArr = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].index === this.tableData[index - 1].index) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      });
    },

    //合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //表格合并行
      if (columnIndex < 10) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    //下载
    downModel() {
      validate()
        .then((res) => {
          // console.log(res);
          if (res.success) {
            this.downDisabled = true;
            this.xhr = new XMLHttpRequest();
            this.xhr.open(
              "GET",
              rootUrl + "/multiple-charge/downloadTemplate",
              true
            );
            this.xhr.responseType = "blob";
            var vmThis = this;
            this.xhr.onload = () => {
              if (this.xhr.status === 200) {
                if (
                  this.xhr.response &&
                  this.xhr.response.size &&
                  this.xhr.response.size > 0
                ) {
                  let file = this.xhr.response;
                  console.log(this.xhr.response);
                  let fileName = "多人扣款模板.xlsx";
                  if ("msSaveOrOpenBlob" in navigator) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                  } else {
                    let fileUrl = window.URL.createObjectURL(file);
                    let a = document.createElement("a");
                    a.download = fileName;
                    a.href = fileUrl;
                    document.getElementsByTagName("body")[0].appendChild(a);
                    a.click();
                    a.parentNode.removeChild(a);
                    window.URL.revokeObjectURL(fileUrl);
                  }
                }
                this.downDisabled = false;
              } else {
                //
                this.downDisabled = false;
              }
            };
            this.xhr.setRequestHeader("token", this.$store.state.loginToken);
            this.xhr.send();
          } else {
            this.showMessage("error", res.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    exportExcels() {
      this.exportDisabled = true;
      this.showMessage("info", "导出中，请稍候");
      this.xhr = new XMLHttpRequest();
      this.xhr.open("GET", rootUrl + "/multiple-charge/export", true);
      this.xhr.responseType = "blob";
      var vmThis = this;
      this.xhr.onload = () => {
        if (this.xhr.status === 200) {
          if (
            this.xhr.response &&
            this.xhr.response.size &&
            this.xhr.response.size > 0
          ) {
            let file = this.xhr.response;
            let fileName = "多人扣款导出.xlsx";
            if ("msSaveOrOpenBlob" in navigator) {
              window.navigator.msSaveOrOpenBlob(file, fileName);
            } else {
              let fileUrl = window.URL.createObjectURL(file);
              let a = document.createElement("a");
              a.download = fileName;
              a.href = fileUrl;
              document.getElementsByTagName("body")[0].appendChild(a);
              a.click();
              a.parentNode.removeChild(a);
              window.URL.revokeObjectURL(fileUrl);
            }
          }
          this.exportDisabled = false;
        } else {
          //
          this.exportDisabled = false;
        }
      };
      this.xhr.setRequestHeader("token", this.$store.state.loginToken);
      this.xhr.send();
    },
    searchDetails(details) {
      this.dialogVisible = true;
      this.selectDetailsId = details.id;
      this.detailsTitle = `实扣明细 ${details.empName}(${details.empNo})`;
      getMultipleDetails(details.id)
        .then((res) => {
          console.log(res);
          this.detailsTable = res.data.rows;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    delDetails(id) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delMutipleDetails(id)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.showMessage("success", "删除成功");
              } else {
                this.showMessage("error", res);
              }
              getMultipleDetails(this.selectDetailsId)
                .then((res) => {
                  console.log(res);
                  this.detailsTable = res.data.rows;
                })
                .catch((res) => {
                  console.log(res);
                });
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.showMessage("info", "取消删除");
        });
    },
    //设置单元格背景
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return "border-color:#ccc!important;";
    },
    closeAddDetails() {
      this.queryList();
    },
    delMultipleCharge() {
      console.log(this.selectDeleteId);
      if (this.selectDeleteId == "") {
        this.showMessage("error", "请选择后再进行删除");
        return false;
      }
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delMultiple(this.selectDeleteId)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.showMessage("success", "删除成功");
                this.currentPage = 1;
                this.queryList();
              } else {
                this.showMessage("error", res);
                this.queryList();
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.showMessage("info", "取消删除");
        });
    },
    closeAddDetailsItem() {
      this.form = {};
    },
  },
};
</script>

<style>
.el-radio__inner {
  border-radius: 0 !important;
}
.el-date-editor .el-range-separator {
  padding: 0 !important;
}
</style>
